// @ts-nocheck
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useUpcomingEventsForTravel() {
  return useQuery({
    queryKey: ["upcoming-events-for-travel"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("events")
        .select("id, name, start_date, end_date, venue_id, venue_name, venue_city, venue_state, additional_venue_ids")
        .gte("end_date", new Date().toISOString().split("T")[0])
        .order("start_date");
      if (error) throw error;
      return data;
    },
  });
}

export function useTravelBookings(eventId: string | null) {
  return useQuery({
    queryKey: ["travel-bookings", eventId],
    enabled: !!eventId,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("manage_travel_bookings")
        .select("*, staff:event_staff(*)")
        .eq("event_id", eventId!);
      if (error) throw error;
      return data;
    },
  });
}

export function useAllTravelBookings() {
  return useQuery({
    queryKey: ["travel-bookings-all"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("manage_travel_bookings")
        .select("*, staff:event_staff(*)")
        .order("departure_date", { ascending: false });
      if (error) throw error;
      return data;
    },
  });
}

export function useTravelBudgets(eventId: string | null) {
  return useQuery({
    queryKey: ["travel-budgets", eventId],
    enabled: !!eventId,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("manage_travel_budgets")
        .select("*")
        .eq("event_id", eventId!);
      if (error) throw error;
      return data;
    },
  });
}

export function useTravelSummary(eventId: string | null) {
  return useQuery({
    queryKey: ["travel-summary", eventId],
    enabled: !!eventId,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("manage_travel_summary")
        .select("*")
        .eq("event_id", eventId!);
      if (error) throw error;
      return data;
    },
  });
}

export function useStaffTravelStatus(eventId: string | null) {
  return useQuery({
    queryKey: ["staff-travel-status", eventId],
    enabled: !!eventId,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("manage_staff_travel_status")
        .select("*")
        .eq("event_id", eventId!);
      if (error) throw error;
      return data;
    },
  });
}

export function useStaffHomeLocations() {
  return useQuery({
    queryKey: ["staff-home-locations"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("manage_staff_home_locations")
        .select("*, staff:event_staff(*)");
      if (error) throw error;
      return data;
    },
  });
}

export function useEventStaffForTravel() {
  return useQuery({
    queryKey: ["event-staff-for-travel"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("event_staff")
        .select("*")
        .order("name");
      if (error) throw error;
      return data;
    },
  });
}

export function useStaffAssignmentsForEvent(eventId: string | null) {
  return useQuery({
    queryKey: ["staff-assignments-for-travel", eventId],
    enabled: !!eventId,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("manage_staff_event_assignments")
        .select("staff_id")
        .eq("event_id", eventId!);
      if (error) throw error;
      return data;
    },
  });
}
